import React from 'react';
import { getIsStockClearance } from 'utils/productUtils';
import useIsLogged from 'utils/useIsLogged';

const StockClearance = ({ product }) => {
  
  const isLogged = useIsLogged()
  const isStockClearance = getIsStockClearance(product)

  if(!isStockClearance) return null

  return <>
    {isLogged && <div data-test-id='ysxY' className="gray-line mt2"></div>}

    <div data-test-id='LlDd' className="flex row alignCenter gap2 mt2">
      <div className="stock-clearance-icon">
        !
      </div>
      <div className="stock-clearance-label">
        Ultimele bucăți în stoc
      </div>
    </div>

    <div data-test-id='ysxZ' className="gray-line mt2 mb2"></div>
</>


};

export default StockClearance;